import React from "react";
import {
  Admin,
  Role,
  User,
  Login,
  PasswordReset,
  BlogCategory,
  Menu,
  Gallery,
  GalleryCreate,
  GalleryEdit,
  TicketCategory,
  Tickets,
  Setting,
  Discount,
  Blog,
  TicketCategoryFAQ,
  PackageType,
  Attribute,
  AttributeEdit,
  Brand,
  Sms,
  Watermark,
  BrandEdit,
  ItemProduct,
  ItemProductCreate,
  ItemProductEdit,
  ProductCategory,
  ProductCategoryEdit,
  ProductFilterEdit,
  ProductFilter,
  PriceParameter,
  ProductCategoryHasAssignable,
  Products,
  ProductUpdateOrCreate,
  ProductCrawler,
  BlogUpdateOrCreate,
  Supplier,
  Major,
} from "./../pages";
import { Route, Routes } from "react-router-dom";
import { connect } from "react-redux";
import Orders from "../pages/order";
import Invoice from "../pages/order/invoice";
import Depot from "../pages/depot";
import Marketer from "../pages/marketer";
import MarketerProfile from "../pages/marketer/profile";
import DocumentPage from "../pages/marketer/doc";
import Contract from "../pages/marketer/contract";
import ContractTemplate from "../pages/marketer/contractTemplate";
import Deposits from "../pages/marketer/deposits";
import Commission from "../pages/marketer/commission";
import CommissionPeriod from "../pages/marketer/commissionPeriod";
import ContractView from "../pages/marketer/contractView";
import Rewards from "../pages/marketer/reward";
import AsnafProduct from "../pages/asnaf/product";
import AsnafBranch from "../pages/asnaf/branch";
import Comments from "../pages/comments/comments";
import MarketerRequest from "../pages/requests";
import PeriodList from "../pages/period";
import PeriodReport from "../pages/period/report";
import MarketerOperation from "../pages/marketer/operation";
import Transactions from "../pages/transaction";
import Transaction from "../pages/transaction/show";
import Notifications from "../pages/notification";
import OrderProductPins from "../pages/product/pins";
import UserLog from "../pages/user/log";
import TicketReport from "../pages/ticket/report";
import Finance from "../pages/finance";
import FinancePerUser from "../pages/finance/per_user";
import ContactUs from "../pages/contactUs";
import LandingPage from "../components/landingPage/index";
import LandingPageCreate from "../components/landingPage/create";
import Region from "../pages/region";
import HeaderBannerList from "../pages/header-banner";
import HeaderBannerCreate from "../pages/header-banner/create";
import HeaderBannerEdit from "../pages/header-banner/edit";

const RouterComponent = (props) => {
  const { authReducer } = props;

  return !authReducer.login ? (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/password/reset" element={<PasswordReset />} />
    </Routes>
  ) : (
    <Routes>
      <Route path="/" element={<Admin />} />
      <Route path="/depot" element={<Depot />} />
      <Route path="/orders" element={<Orders />} />
      <Route path="/orders/:id" element={<Invoice />} />
      {/*<Route path="/orders/major/:id" element={<Invoice />} />*/}
      {/*<Route path="/orders/major" element={<OrdersMajor />} />*/}

      {/* product routes */}
      <Route path="/product" element={<Products />} />
      <Route path="/product/crawler" element={<ProductCrawler />} />
      <Route
        path="/product/updateOrCreate/:id?"
        element={<ProductUpdateOrCreate />}
      />
      <Route path="/product/item" element={<ItemProduct />} />
      <Route path="/product/item/create" element={<ItemProductCreate />} />
      <Route path="/product/item/:id/edit" element={<ItemProductEdit />} />
      <Route path="/product/category" element={<ProductCategory />} />
      <Route
        path="/product/category/:id/edit"
        element={<ProductCategoryEdit />}
      />
      <Route
        path="/product/category/:id/assignable/:title"
        element={<ProductCategoryHasAssignable />}
      />
      <Route path="/product/filter" element={<ProductFilter />} />
      <Route path="/product/filter/:id/edit" element={<ProductFilterEdit />} />
      <Route path="/product/brand" element={<Brand />} />
      <Route path="/product/brand/:id/edit" element={<BrandEdit />} />
      <Route path="/product/attribute" element={<Attribute />} />
      <Route path="/product/attribute/:id/edit" element={<AttributeEdit />} />
      <Route path="/product/packageType" element={<PackageType />} />
      <Route path="/product/priceParameter" element={<PriceParameter />} />
      <Route path="/product/pins" element={<OrderProductPins />} />

      {/* regions */}
      <Route path="/major" element={<Major />} />
      <Route path="/region" element={<Region />} />

      {/* comments */}
      <Route path="/comments" element={<Comments />} />

      {/* blog routes */}
      <Route path="/blog" element={<Blog />} />
      <Route
        path="/blog/updateOrCreate/:id?/:slug?"
        element={<BlogUpdateOrCreate />}
      />
      <Route path="/blog/category" element={<BlogCategory />} />
      <Route path="/menu" element={<Menu />} />

      {/* setting */}
      <Route path="/setting" element={<Setting />} />
      <Route path="/discount" element={<Discount />} />
      <Route path="/sms" element={<Sms />} />

      {/* ticket */}
      <Route path="/ticket" element={<Tickets />} />
      <Route path="/ticket/category" element={<TicketCategory />} />
      <Route path="/ticket/category/faq" element={<TicketCategoryFAQ />} />
      <Route path="/ticket/operator/report" element={<TicketReport />} />

      {/* gallery */}
      <Route path="/gallery" element={<Gallery />} />
      <Route path="/watermark" element={<Watermark />} />
      <Route path="/gallery/create" element={<GalleryCreate />} />
      <Route path="/gallery/:id/edit" element={<GalleryEdit />} />

      {/* marketer */}
      <Route path="/marketer" element={<Marketer />} />
      <Route path="/marketer/contract/commission" element={<Commission />} />
      <Route
        path="/marketer/contract/commission/period"
        element={<CommissionPeriod />}
      />
      <Route path="/operation" element={<MarketerOperation />} />
      <Route path="/marketer/deposits/:id" element={<Deposits />} />
      <Route path="/reward" element={<Rewards />} />
      <Route path="/marketer/:id" element={<MarketerProfile />} />
      <Route path="/document" element={<DocumentPage />} />
      <Route path="/contract" element={<Contract />} />
      <Route path="/contracts/template" element={<ContractTemplate />} />
      <Route path="/contract/:id" element={<ContractView />} />

      {/* user bundle */}
      <Route path="/users" element={<User />} />
      <Route path="/users/roles" element={<Role />} />
      <Route path="/users/log" element={<UserLog />} />

      {/* supplier */}
      <Route path="/supplier" element={<Supplier />} />

      {/* asnaf */}
      <Route path="/asnaf/product" element={<AsnafProduct />} />
      <Route path="/asnaf/branch" element={<AsnafBranch />} />

      {/* requests */}
      <Route path="/requests" element={<MarketerRequest />} />

      {/* period report */}
      <Route path="/period" element={<PeriodList />} />
      <Route path="/period/report" element={<PeriodReport />} />

      {/* transactions */}
      <Route path="/transactions" element={<Transactions />} />
      <Route path="/transactions/:id" element={<Transaction />} />

      {/* finance */}
      <Route path="/finance" element={<Finance />} />
      <Route path="/finance/group" element={<FinancePerUser />} />

      {/* notifications */}
      <Route path="/notifications" element={<Notifications />} />

      {/* contact us */}
      <Route path="/contactUs" element={<ContactUs />} />

      {/* landing */}
      <Route path="/landing_page" element={<LandingPage />} />
      <Route path="/landing_page/create/:id" element={<LandingPageCreate />} />

      {/* header banner routes */}
      <Route path="/header-banner" element={<HeaderBannerList />} />
      <Route path="/header-banner/create" element={<HeaderBannerCreate />} />
      <Route path="/header-banner/edit/:id" element={<HeaderBannerEdit />} />
    </Routes>
  );
};

const mapStateToProps = (state) => ({
  authReducer: state.authReducer,
});

export default connect(mapStateToProps)(RouterComponent);
